import { isValidEmail } from '@domain-group/javascript-utils'

export type AgencyContactModel = {
  agency_id: number,
  cache_key: number,
  contact_type: string,
  email: string,
  id: number,
  name: string,
  phone: string,
}

export type AgencyContactRequestOptions = {}

const state = {
  agency_id: undefined,
  contact_type: '',
  email: '',
  id: null,
  name: '',
  phone: '',
}

export const requiredFields = [
  { key: 'contact_type' },
  { key: 'email', validation: isValidEmail, invalidMessage: 'Invalid Email format' },
  { key: 'name' },
  { key: 'phone' },
]

export default state
